module.exports = __webpack_public_path__ + "static/blue-j-logo-5495bf9d2a0e937eb405ad09a96926a9.png";